import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ScreenFrame, ListCard, EmptyState, ViewToggle } from '../PrototypeShared';
import { Assignment } from '@mui/icons-material';

const MOCK_AUDITS = [
  { id: 'A1', retailer: 'Customer North', date: '2024-03-01', status: 'Passed' },
  { id: 'A2', retailer: 'Foodservice', date: '2024-03-05', status: 'Pending' },
];

export default function AuditsScreen() {
  const [view, setView] = useState('list');

  return (
    <ScreenFrame
      title="Audits"
      actions={
        <>
          <ViewToggle value={view} onChange={setView} options={[{ value: 'list', label: 'With data' }, { value: 'empty', label: 'Empty' }]} />
          <Button component={Link} to="/prototype/audits/new" startIcon={<Add />} variant="contained" size="small">New audit</Button>
        </>
      }
    >
      {view === 'empty' && (
        <EmptyState icon={Assignment} title="No audits" description="Create your first audit." actionLabel="New audit" onAction={() => window.location.assign('/prototype/audits/new')} />
      )}
      {view === 'list' && (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {MOCK_AUDITS.map((a) => (
            <ListCard key={a.id} title={`Audit ${a.id} — ${a.retailer}`} subtitle={a.date} status={a.status} to={`/prototype/audits/${a.id}`} />
          ))}
        </Box>
      )}
    </ScreenFrame>
  );
}
